import React from 'react';

import Box from "@mui/material/Box";

export interface Props {
    children?: JSX.Element
}

const CCOIcon = (props: Props) => {
    return <Box component="span" sx={{
        height: 48,
        width: 48,
        padding: 4,
        borderRadius: '50%',
        backgroundColor: "primary.main",
        '.MuiSvgIcon-root ': {
            color: "primary.contrastText",
            position: 'relative',
            top: '3px'
        },
        '& path':
            {
                height: '48!important'
            }

    }}>
        {props.children}
    </Box>

};

export default CCOIcon;
